import { ApiHttpService } from '../ApiHttpService';
import { ShippingOptionSerializer } from '../serializers/ShippingOptionSerializer';
import { ShippingOptionsByLocationSerializer } from '../serializers/ShippingOptionsByLocationSerializer';
import { ShippingOption } from '../../models/ShippingOption';
import { ShippingOptionsByLocation } from '../../models/ShippingOptionsByLocation';

const SHIPPING_PATH = 'usuario/OpcionesDeFletes';
const SHIPPING_LOCATION_PATH = 'usuario/OpcionesDeFletesLocalidad';

class ShippingOptionsController {
  static async all(addressId, cart) {
    const authenticated = true;
    const params = {
      IDDIreccion: addressId,
      Carrito: cart.map(item => ({
        key: item.productId,
        value: item.amount,
      })),
    };
    const response = await ApiHttpService.post(SHIPPING_PATH, params, authenticated);
    let deSerializedShippingOptions = response.data;
    deSerializedShippingOptions = ShippingOptionSerializer.deSerialize(deSerializedShippingOptions);
    const shippingOptions = deSerializedShippingOptions.map(option => new ShippingOption(option));
    return shippingOptions;
  }

  static async getByLocation(location) {
    const params = {
      localidad: location,
    };
    const response = await ApiHttpService.get(SHIPPING_LOCATION_PATH, params);
    let deSerializedShippingOptions = response.data;
    let shippingOptions = {};
    if (deSerializedShippingOptions) {
      deSerializedShippingOptions = ShippingOptionsByLocationSerializer
        .deSerialize(deSerializedShippingOptions);
      shippingOptions = new ShippingOptionsByLocation(deSerializedShippingOptions);
    }
    return shippingOptions;
  }
}

export { ShippingOptionsController };



// WEBPACK FOOTER //
// ./src/networking/controllers/ShippingOptionsController.js